import { render, staticRenderFns } from "./SalonPhotoSlides.vue?vue&type=template&id=0ee4586b&"
import script from "./SalonPhotoSlides.vue?vue&type=script&lang=js&"
export * from "./SalonPhotoSlides.vue?vue&type=script&lang=js&"
import style0 from "./SalonPhotoSlides.vue?vue&type=style&index=0&id=0ee4586b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports